export * from "./SpectatedSolitaire";
export { default } from "./SpectatedSolitaire";
